<template>
    <h1>Pedidos de Ausência</h1>
    <AbsenceRequestManagementTable />
</template>

<script setup>

import AbsenceRequestManagementTable from '@/components/absences/requests/AbsenceRequestManagementTable.vue';
</script>

<style scoped>

</style>